/*
  Selector de variante sin recarga.

  El enlace sigue siendo un <a> con ?variant=, asi que sin JavaScript funciona
  igual: recarga y elige. Con JavaScript se intercepta el clic y se cambia todo
  en sitio, que es lo que espera cualquiera en 2026. Recargar para elegir un
  color pierde el scroll y hace parpadear la pagina.
*/
(function () {
  'use strict';

  var bloque = document.querySelector('[data-lander-compra]');
  if (!bloque) return;

  var enlaces = bloque.querySelectorAll('[data-variante]');
  if (!enlaces.length) return;

  var campoId = bloque.querySelector('input[name="id"]');
  var boton = bloque.querySelector('button[name="add"]');
  var precio = bloque.querySelector('[data-precio]');
  // Se busca por clase: image_tag no admite atributos con guion como parametro.
  var foto = bloque.querySelector('.lander-buy__shot');
  var textoAgotado = bloque.getAttribute('data-texto-agotado') || '';
  var textoComprar = boton ? boton.getAttribute('data-texto-comprar') || boton.textContent.trim() : '';

  function elegir(enlace) {
    enlaces.forEach(function (otro) {
      var activo = otro === enlace;
      otro.classList.toggle('is-elegido', activo);
      if (activo) {
        otro.setAttribute('aria-current', 'true');
      } else {
        otro.removeAttribute('aria-current');
      }
    });

    if (campoId) campoId.value = enlace.getAttribute('data-variante');
    if (precio && enlace.getAttribute('data-precio')) {
      precio.textContent = enlace.getAttribute('data-precio');
    }

    var disponible = enlace.getAttribute('data-disponible') === 'true';
    if (boton) {
      boton.disabled = !disponible;
      boton.textContent = disponible ? textoComprar : textoAgotado;
    }

    var url = enlace.getAttribute('data-foto');
    if (foto && url) {
      // Se quita el srcset: si se deja, el navegador puede seguir sirviendo la
      // foto del color anterior desde su propia lista de tamaños.
      foto.removeAttribute('srcset');
      foto.removeAttribute('sizes');
      foto.src = url;
    }

    // La URL acompaña a la elección, sin añadir una entrada al historial:
    // así compartir el enlace o recargar conserva el color, pero el botón
    // de atrás sigue llevando a la página anterior y no al otro color.
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', enlace.getAttribute('href').split('#')[0]);
    }
  }

  enlaces.forEach(function (enlace) {
    enlace.addEventListener('click', function (e) {
      // Clic con modificador o botón central: que el navegador haga lo suyo.
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      elegir(enlace);
    });
  });
})();
